import { useState, useEffect } from 'react';
import LeadCaptureForm from './LeadCaptureForm';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/7b1003cad5eb63ca5e949a5a606f349d.jpg"
            alt="Beautiful El Paso home"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-verified-badge-fill text-teal-400 text-xl"></i>
              <span className="text-sm font-medium">Trusted El Paso Cash Home Buyers Since 2016</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Sell Your El Paso House <span className="text-teal-400">Fast for Cash</span>
            </h1>
            
            <p className="text-xl md:text-2xl mb-8 text-gray-100 leading-relaxed">
              Get a fair cash offer in 24 hours. No repairs, no fees, no hassles. Close on your timeline - as fast as 7 days.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-check-line text-teal-400 text-2xl"></i>
                </div>
                <span className="text-base">No Realtor Commissions</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-check-line text-teal-400 text-2xl"></i>
                </div>
                <span className="text-base">Close in 7 Days</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-check-line text-teal-400 text-2xl"></i>
                </div>
                <span className="text-base">Sell As-Is Condition</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-check-line text-teal-400 text-2xl"></i>
                </div>
                <span className="text-base">Zero Hidden Fees</span>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <a href="tel:+1-915-206-5814" className="inline-flex items-center space-x-2 px-8 py-4 bg-white text-gray-900 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-fill"></i>
                <span>(915) 206-5814</span>
              </a>
              <div className="flex items-center space-x-2">
                <div className="flex -space-x-2">
                  <div className="w-10 h-10 rounded-full bg-teal-500 border-2 border-white"></div>
                  <div className="w-10 h-10 rounded-full bg-orange-500 border-2 border-white"></div>
                  <div className="w-10 h-10 rounded-full bg-indigo-500 border-2 border-white"></div>
                </div>
                <div className="text-sm">
                  <div className="font-semibold">We Buy, sell and rent real estate</div>
                  <div className="text-gray-300">in El Paso Area</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Lead Capture Form */}
          <div className="lg:ml-auto w-full max-w-md">
            <LeadCaptureForm />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}